function ProductReducer(state, action){
    switch(action.type){
        case 'like':
            return {
                product: [
                    ...state.product.filter(item => {
                        if(item.id == action.data){
                            item.liked = action.status;
                            item.like = action.like;
                            return item;
                        }else{
                            return item;
                        }
                    })
                ],
                cat: {
                    ...state.cat
                }
            }
    }
}

export default ProductReducer;